import { fizz as fizzBase } from "@thirdparty/companies";

import { GtbCustomApp } from "../gtb/types";
import { gtb } from "../gtb";

export const fizz: GtbCustomApp = {
  ...fizzBase,
  routes: gtb.routes,
};
